export default "__VITE_ASSET__$UTgHfb3__"